import { useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal, PageHero, useSeo } from "../components/Shared";
import { EMAIL, POSITIONS } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Career() {
  useSeo(
    "Career | Dishan International Group",
    "Build your career inside a strategic ecosystem. Apply to join the Dishan International Group team."
  );
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/careers`, Object.fromEntries(new FormData(e.currentTarget)));
      setSent(true);
      toast.success("Application received. Our people team will be in touch.");
      e.currentTarget.reset();
    } catch {
      toast.error(`We couldn't send that just now. Please email ${EMAIL}.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHero
        eyebrow="Career"
        titleKey="career.hero.title" title="Do work that moves people forward."
        subtitleKey="career.hero.subtitle" subtitle="Join a team working across strategy, brand, education and human potential, where thinking clearly matters as much as executing well."
      />
      <main>
        <section className="section">
          <div className="container form-layout">
            <Reveal>
              <span className="eyebrow">Why Dishan</span>
              <h2>A career with range.</h2>
              <p>Consultants, strategists, educators, researchers and wellness professionals work side by side here. You will see more contexts in one year than most roles offer in five.</p>
              <ul className="check-list">
                <li>Founder-led mentorship and real client exposure</li>
                <li>Cross-division projects across consulting, education and wellness</li>
                <li>A culture that values judgement, empathy and craft</li>
              </ul>
            </Reveal>
            <Reveal delay={0.1}>
              <form className="form-card" onSubmit={submit} data-testid="career-form">
                <h3>Career application</h3>
                <div className="form-row">
                  <label>Full name<input name="name" required placeholder="Your name" data-testid="career-name-input" /></label>
                  <label>Email<input name="email" type="email" required placeholder="you@email.com" data-testid="career-email-input" /></label>
                </div>
                <div className="form-row">
                  <label>Phone<input name="phone" placeholder="+91" data-testid="career-phone-input" /></label>
                  <label>Position of interest
                    <select name="position" required data-testid="career-position-select">
                      <option value="">Select a role</option>
                      {POSITIONS.map((p) => <option key={p}>{p}</option>)}
                    </select>
                  </label>
                </div>
                <div className="form-row">
                  <label>Years of experience<input name="experience" placeholder="e.g. 3 years" data-testid="career-experience-input" /></label>
                  <label>LinkedIn profile<input name="linkedin" placeholder="linkedin.com/in/you" data-testid="career-linkedin-input" /></label>
                </div>
                <label>Portfolio / resume link<input name="portfolio" placeholder="Drive, website or portfolio URL" data-testid="career-portfolio-input" /></label>
                <label>Why Dishan, and why you?<textarea name="message" required rows={4} placeholder="Tell us about your strengths and what you want to build here..." data-testid="career-message-input" /></label>
                <button className="btn btn-primary form-submit" type="submit" disabled={loading} data-testid="career-submit-button">
                  {loading ? "Sending…" : "Submit Application"} <ArrowUpRight size={16} />
                </button>
                {sent && <p className="success-message" data-testid="career-success-message">Thank you, your application has been received.</p>}
              </form>
            </Reveal>
          </div>
        </section>
      </main>
    </>
  );
}
